import myAxios from './myAxios';

export const fetchCurrentUser = () => (
  (dispatch) => {
    return myAxios.get(routes().account)
      .then((response) => {
        dispatch(fetchCurrentUserSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        console.error(err)
      })
  }
);

export const fetchCurrentUserSuccess = (payload) => ({type: 'FETCH_CURRENT_USER_SUCCESS', payload });
